import type { TicketTier } from '../../lib/catalog';

// Extracted so the hardcoded Event page and the CMS ticket block share ONE definition of
// what "buyable" means. Two copies of this rule would eventually disagree, and the one
// that disagreed would be deciding whether somebody can buy a ticket.

/** A tier is buyable only when active, in its sale window, and not sold out. */
export function tierAvailability(tier: TicketTier): {
  buyable: boolean;
  label: string;
  tone: 'ok' | 'low' | 'gone';
} {
  if (tier.status !== 'active') return { buyable: false, label: 'Unavailable', tone: 'gone' };
  if (tier.remaining <= 0) return { buyable: false, label: 'Sold out', tone: 'gone' };

  const now = Date.now();
  if (tier.saleStart && new Date(tier.saleStart).getTime() > now) {
    return { buyable: false, label: 'Not yet on sale', tone: 'gone' };
  }
  if (tier.saleEnd && new Date(tier.saleEnd).getTime() < now) {
    return { buyable: false, label: 'Sales closed', tone: 'gone' };
  }
  if (tier.remaining <= 10) {
    return { buyable: true, label: `Only ${tier.remaining} left`, tone: 'low' };
  }
  return { buyable: true, label: `${tier.remaining} available`, tone: 'ok' };
}
